var map = {
	"./Uptech-marker-alerts-icon-high-animal.png": 8908,
	"./Uptech-marker-alerts-icon-high-deformation.png": 9468,
	"./Uptech-marker-alerts-icon-high-electric-tower.png": 9613,
	"./Uptech-marker-alerts-icon-high-intrusion.png": 2684,
	"./Uptech-marker-alerts-icon-high-landslide.png": 6448,
	"./Uptech-marker-alerts-icon-high-leak.png": 92,
	"./Uptech-marker-alerts-icon-high-rock-falling.png": 8656,
	"./Uptech-marker-alerts-icon-high-temperature.png": 6328,
	"./Uptech-marker-alerts-icon-high-vehicle.png": 592,
	"./Uptech-marker-alerts-icon-high.png": 1676,
	"./Uptech-marker-alerts-icon-intermediate-animal.png": 3296,
	"./Uptech-marker-alerts-icon-intermediate-deformation.png": 1836,
	"./Uptech-marker-alerts-icon-intermediate-electric-tower.png": 9632,
	"./Uptech-marker-alerts-icon-intermediate-intrusion.png": 4780,
	"./Uptech-marker-alerts-icon-intermediate-landslide.png": 7256,
	"./Uptech-marker-alerts-icon-intermediate-leak.png": 3128,
	"./Uptech-marker-alerts-icon-intermediate-rock-falling.png": 5708,
	"./Uptech-marker-alerts-icon-intermediate-temperature.png": 4300,
	"./Uptech-marker-alerts-icon-intermediate-vehicle.png": 4075,
	"./Uptech-marker-alerts-icon-intermediate.png": 7332,
	"./Uptech-marker-alerts-icon-low-animal.png": 7896,
	"./Uptech-marker-alerts-icon-low-deformation.png": 6340,
	"./Uptech-marker-alerts-icon-low-electric-tower.png": 5423,
	"./Uptech-marker-alerts-icon-low-intrusion.png": 7216,
	"./Uptech-marker-alerts-icon-low-landslide.png": 6791,
	"./Uptech-marker-alerts-icon-low-leak.png": 3900,
	"./Uptech-marker-alerts-icon-low-rock-falling.png": 9912,
	"./Uptech-marker-alerts-icon-low-temperature.png": 2876,
	"./Uptech-marker-alerts-icon-low-vehicle.png": 9124,
	"./Uptech-marker-alerts-icon-low.png": 2292,
	"./Uptech-marker-alerts-icon-ok.png": 9096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1440;